import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

import { useNavigationHistory } from './useNavigationHistory';

export const useGoBack = (fallbackRoute: string = ROUTES.AUTHORIZED.LANDING) => {
  const navigate = useNavigate();
  const { hasHistory, goBack } = useNavigationHistory();

  return useCallback(() => {
    if (hasHistory) {
      goBack();
    } else {
      navigate(fallbackRoute, { replace: true });
    }
  }, [navigate, hasHistory, goBack, fallbackRoute]);
};
